export default "__VITE_ASSET__XJMhHKMP__"